import React from "react";

const InsuranceContext = React.createContext();

export default InsuranceContext;
